// Detects the D6 per-turn mutation-budget notice in an assistant message's
// text (backend/internal/agent/tools/registry.go's
// `MakeMutationBudgetedExecutor`: "I've made %d updates this turn — say
// \"continue\" if you'd like me to keep going."). There is no structured
// frame for this (the budget-exceeded tool result is `ShowToUser: false` /
// `RenderNever` — the model narrates it as ordinary text), so the dock
// detects the BUDGET state from the rendered copy itself.
const BUDGET_PATTERN = /made (\d+) updates this turn/i;

export function detectBudgetNotice(text: string): { writesThisTurn: number } | null {
  const match = BUDGET_PATTERN.exec(text);
  if (!match) return null;
  const writesThisTurn = Number(match[1]);
  if (!Number.isFinite(writesThisTurn)) return null;
  return { writesThisTurn };
}
